export default __webpack_public_path__ + "static/media/integrationsActive.832c861f.svg";